import { createActions, createState, createReducer } from 'reduxsauce-crud'

export const PaymentTypesMsiRedux = createActions({}, {
    prefix: 'PAYMENT_TYPES_MSI_',
    defaultActions: {
        get: true,
    },
}, )

const { Types, Creators } = PaymentTypesMsiRedux
export const PaymentTypesMsiTypes = Types
export default Creators

export const INITIAL_STATE = createState({}, {
    get: true,
})


export const reducer = createReducer(
    INITIAL_STATE, {}, {
        defaultActions: {
            get: true,
        },
        Types,
    },
)


// WEBPACK FOOTER //
// ./src/Data/Redux/PaymentTypesMsiRedux.js